import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_ACCOUNT,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_COMMON_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_EVIDENCE,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_IMAGE_LIST,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_PRICE_LIST,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_MULTIMEDIA_FILE_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OFFER_LISTING_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OVERALL_MULTIMEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_PRODUCT_LISTING_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SELLER,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SOCIAL_MEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_ACCOUNT,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_COMMON_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_EVIDENCE,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_LINK_IMAGE_LIST,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_LINK_PRICE_LIST,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_MULTIMEDIA_FILE_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_OFFER_LISTING_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_OVERALL_MULTIMEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_PRODUCT_LISTING_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_SELLER,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_SOCIAL_MEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_FORCE_VALIDATION,
} from '../../../actions/actionTypes';

const defaultState = { force: false };

const validation = (state = defaultState, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_SET_FORCE_VALIDATION:
      return { ...state, force: true };

    case INCIDENT_DETAILS_CLEAR:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_ACCOUNT:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_COMMON_LINK_DATA:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_EVIDENCE:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_IMAGE_LIST:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_PRICE_LIST:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_MULTIMEDIA_FILE_LINK_DATA:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OFFER_LISTING_LINK_DATA:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OVERALL_MULTIMEDIA_LINK_DATA:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_PRODUCT_LISTING_LINK_DATA:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SELLER:
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SOCIAL_MEDIA_LINK_DATA:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_ACCOUNT:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_COMMON_LINK_DATA:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_EVIDENCE:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_LINK_IMAGE_LIST:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_LINK_PRICE_LIST:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_MULTIMEDIA_FILE_LINK_DATA:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_OFFER_LISTING_LINK_DATA:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_OVERALL_MULTIMEDIA_LINK_DATA:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_PRODUCT_LISTING_LINK_DATA:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_SELLER:
    case INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_SOCIAL_MEDIA_LINK_DATA:
      return defaultState;

    default:
      return state;
  }
};

export default validation;
